export default __webpack_public_path__ + "static/DawidMalinowski-9c4117757ed56477b865142a6d21610a.png";